import t from 'react-translate';

/**
 * Returns the plain-text title of a section for use in accessible labels.
 * Falls back to "Accordion Section N" when the header has no visible text.
 */
/* @ngInject */
export function getSectionAccessibleName(header: string, index: number): string {
  const div = document.createElement('div');
  div.innerHTML = header;
  const text = div.textContent?.trim();
  if (text) return text;
  return t.LECTURE_PAGES.COMPONENTS.ACCORDION.SECTION.DESCRIPTION_WITH_INDEX(String(index + 1));
}

/* @ngInject */
export function getSectionAriaLabel(expanded: boolean, header: string, index: number): string {
  const name = getSectionAccessibleName(header, index);
  return expanded
    ? t.LECTURE_PAGES.COMPONENTS.ACCORDION.CLICK_TO_COLLAPSE_SECTION(name)
    : t.LECTURE_PAGES.COMPONENTS.ACCORDION.CLICK_TO_EXPAND_SECTION(name);
}

/**
 * output normalization. If the input contains only html tags without any
 * content we discard it and save an empty script to the Database
 */
/* @ngInject */
export function normalizeHTMLOutput(html: string) {
  const textContainer = document.createElement('span');
  textContainer.innerHTML = html;

  // if it doesn't contain any text, image of embedded content return just the empty string
  if (textContainer.textContent === '' && !textContainer.querySelector('img, iframe')) {
    return '';
  }

  return html;
}

/**
 * input normalization. If the response coming from the Database is and empty
 * string we use the default html template
 */
/* @ngInject */
export function normalizeHTMLInput(html: string, defaultTemplate: string) {
  if (html === '') {
    return defaultTemplate;
  }
  return html;
}
